<template>
  <div class="mb-4">
    <h1 class="h2 mb-3"><slot /></h1>
    <app-alert />
  </div>
</template>

<script>
import AppAlert from './AppAlert'

export default {
  name: 'PageHeading',
  components: { AppAlert }
}
</script>



// WEBPACK FOOTER //
// src/components/PageHeading.vue